export const XAPI_VERBS = {
    DOWNLOADED: 'downloaded',
    LOGGED_IN: 'logged-in',
    PRESSED: 'pressed',
    VIEWED: 'viewed',
    SELECTED: 'selected',
    OPENED: 'opened',
    CLOSED: 'closed',
    SORTED: 'sorted',
    STARTED: 'started',
    RECORDED: 'recorded',
    READ: 'read',
    FAILED: 'failed',
    ANSWERED: 'answered',
    COMPLETED: 'completed',
    ENCOUNTERED: 'encountered',
    PASSED: 'passed',
};

export const XAPI_OBJECTS = {
    TRO: 'https://api.amplify.com/xapi/objects/text-reading-online',
};
